import {utilsTypeof} from "./utilsTypeof";

export const IsValidRangeUtil = (min: unknown, max: unknown): boolean => {
    return utilsTypeof.isValidNumber(min) &&
        utilsTypeof.isValidNumber(max) &&
        Number(min) <= Number(max);
}